<template>
  <v-dialog
    :value="enableDialog"
    persistent
    width="600"
    @keydown.esc="closeButtonClickEvent"
    @close="closeButtonClickEvent"
  >
    <validation-observer
      ref="observer"
    >
      <v-form>
        <v-card
          v-if="orderId"
          flat
        >
          <v-toolbar flat>
            <v-toolbar-title>指示メモの編集</v-toolbar-title>
          </v-toolbar>
          <v-divider />
          <v-card-text
            style="max-height: 70vh;overflow-y: auto;"
          >
            <!-- ドライバー指示メモ -->
            <v-row>
              <v-col>
                <validation-provider
                  v-slot="{ errors }"
                  name="ドライバー指示メモ"
                  rules="max:300"
                >
                  <v-textarea
                    v-model="forms.driver_instruction"
                    :error-messages="errors"
                    dense
                    hide-details="auto"
                    label="ドライバー指示メモ"
                    no-resize
                    outlined
                    persistent-placeholder
                  >
                    <template v-slot:label>
                      <span>ドライバー指示メモ</span>
                      <span class="ml-1">
                        ({{ forms.driver_instruction?.length || 0 }} / 300)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-textarea>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- 添付ファイル -->
            <v-row>
              <v-col cols="12">
                <dropzone-file
                  :key="fileRefreshKey"
                  :max-size="MANIFEST_ATTACHMENT.MAX_SIZE"
                  :accepts="MANIFEST_ATTACHMENT.ACCEPTS"
                  :max-file-size="MANIFEST_ATTACHMENT.MAX_FILE_SIZE"
                  :alt-file-size-format="MANIFEST_ATTACHMENT.ALT_FILE_SIZE_FORMAT"
                  :alt-file-format="MANIFEST_ATTACHMENT.ALT_FILE_FORMAT"
                  :immediate-delete="MANIFEST_ATTACHMENT.IMMEDIATE_DELETE"
                  :files.sync="forms.order_attachments"
                />
              </v-col>
            </v-row>
            <!-- 検索キーワード -->
            <v-row>
              <v-col>
                <validation-provider
                  v-slot="{ errors }"
                  name="検索キーワード"
                  rules="max: 25"
                >
                  <v-text-field
                    v-model="forms.keyword"
                    :error-messages="errors"
                    dense
                    hide-details="auto"
                    label="検索キーワード"
                    outlined
                    persistent-placeholder
                  >
                    <template v-slot:label>
                      <span>検索キーワード</span>
                      <span class="ml-1">
                        ({{ forms.keyword?.length || 0 }} / 25)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /検索キーワード -->
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn
              @click="closeButtonClickEvent"
            >
              閉じる
            </v-btn>
            <v-btn
              color="primary"
              @click="registerButtonClickEvent"
            >
              更新
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </validation-observer>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import DropzoneFile from '../../../../../../components/DropzoneFile'
import { MANIFEST_ATTACHMENT } from '../../../../../../constants/appConst.js'

export default {
  name: 'EditDriverInstructionDialog',
  components: { DropzoneFile },
  mixins: [],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false,
    },
    orderId: {
      type: Number,
      default: () => null,
    },
  },
  data() {
    return {
      forms: {
        driver_instruction: null,
        order_attachments: [],
        keyword: null,
      },
      fileRefreshKey: 0,
    }
  },
  computed: {
    MANIFEST_ATTACHMENT() {
      return MANIFEST_ATTACHMENT
    }
  },
  watch: {
    enableDialog (newVal) {
      this.$nextTick(() => this.$refs.observer.reset())
      Object.assign(this.$data.forms, this.$options.data().forms)
      if (newVal) {
        this.setVariable()
      }
    },
  },
  created() {
  },
  methods: {
    ...mapActions('DriverOrderAcceptCollectionDriverInstruction', {
      fetchDriverInstruction: 'edit',
      updateDriverInstruction: 'update',
    }),
    setVariable () {
      this.fetchDriverInstruction({ id: this.orderId }).then((content) => {
        this.forms = content
        this.fileRefreshKey++
      })
    },
    closeButtonClickEvent () {
      this.$emit('closeCallback')
    },
    registerButtonClickEvent () {
      let $self = this
      this.$refs.observer.validate().then((result) => {
        if(result) {
          $self.sendRegistrationInformation()
        }
      })
    },
    sendRegistrationInformation () {
      const params = new FormData()
      params.append('driver_instruction', this.nullToBlank(this.forms.driver_instruction))
      params.append('keyword', this.nullToBlank(this.forms.keyword))
      for (const file of this.forms.order_attachments) {
        // 新規 or 削除対象のみ
        if (!file.file && !file._destroy) continue

        if (file.id) {
          params.append('order_attachments_attributes[][id]', file.id)
        }
        params.append('order_attachments_attributes[][file]', file.file)
        if (file._destroy) {
          params.append('order_attachments_attributes[][_destroy]', file._destroy)
        }
      }
      this.updateDriverInstruction({ id: this.orderId, params: params }).then(() => {
        this.$emit('registerCallback')
      })
    },
  }
}
</script>

<style scoped>

</style>
